import { useMemo } from "react";

import { Agent } from "@/api/generated";
import { COMPATIBILITY_AGENTS_PER_PAGE, useCompatibilityAgents } from "@/hooks/useCompatibilityAgents";

// ホームは登録導線（診断結果）と同じ母集団（公開対象全員＝相性面・詳細検索のどちらかで掲載中）から
// 相性順の上位3名だけを取得する（include_all_public=true・per_page=3 の1ページ）。
// マッチ済みはこのセクションから外れて「マッチ中の認定プランナー」へ移るため、
// 繰り上げはせずそのまま減らす（3人ともマッチしたらセクションごと非表示）。
export const DISPLAY_COUNT = COMPATIBILITY_AGENTS_PER_PAGE;

// マッチ済みのプランナーは「マッチ中の認定プランナー」セクションへ移るため、このセクションからは外す。
export const excludeMatchedAgents = (agents: Agent[]): Agent[] => agents.filter((agent) => !agent.is_matched);

// 提案された3人からマッチ済みを除いた分だけを表示する。
// id 欠損（生成型上 optional）のレコードは、カードだけ表示されて詳細タップが無反応になるため描画前に除外する。
// slice は取得件数が増えた場合の保険（通常は DISPLAY_COUNT で足りている）。
export const selectHomeCompatibilityAgents = (agents: Agent[]): Agent[] =>
  excludeMatchedAgents(agents)
    .filter((agent) => agent.id != null)
    .slice(0, DISPLAY_COUNT);

interface UseHomeCompatibilityAgents {
  agents: Agent[];
  loading: boolean;
}

// 相性スコアは登録時に必須の投資力診断（年収・資産・経験・興味・エリア）で算出されるため、
// 投資スタイル診断の状態に関係なくホーム表示時に取得する。
// 取得失敗時は agents が空のままになり、セクションごと非表示に倒れる（ホームは任意コンテンツのため）。
export const useHomeCompatibilityAgents = (): UseHomeCompatibilityAgents => {
  const { agents, isLoading } = useCompatibilityAgents(true, { includeAllPublic: true, perPage: DISPLAY_COUNT });
  const homeAgents = useMemo(() => selectHomeCompatibilityAgents(agents), [agents]);
  return { agents: homeAgents, loading: isLoading };
};
